import React from 'react';
import './DeletableInput.styl';
import {XMarkIcon} from '@components/icon/XMarkIcon';

export default class DeletableInput extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    return this.props.onChange(event.target.value, event);
  }

  onKeyDown(event) {
    if ((event.keyCode === 13 || event.keyCode === 9) && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
      this.props.onNext();
    }
  }

  render() {
    const {onDelete, onFocus, placeholder, value, inputRef} = this.props;

    return (
      <div className="deletable-input" onKeyDown={event => this.onKeyDown(event)}>
        <input
          autoFocus
          ref={inputRef}
          placeholder={placeholder}
          onFocus={onFocus}
          value={value}
          onChange={event => this.onChange(event)}
        />
        <XMarkIcon onClick={onDelete} tooltip="Delete" />
      </div>
    );
  }
}
